import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  EXERCISE_GAP_FILL,
  EXERCISE_GAP_FILL_HINTS,
  EXERCISE_GAP_FILL_QUESTION,
  ExerciseGapFillOptions,
} from './types';
import * as React from 'react';
import { PARAGRAPH_TOGGLE } from '../../plugins-common/ParagraphToggle/types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { EXPLANATIONS } from '../../plugins-common/Explanations/types';
import { ExplanationsElementReadOnly } from './components/readonly/explanations/ExplanationsElement';

const Hints = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/readonly/Hints').then((mod) => mod.Hints))
);
const DoTestExerciseGapFill = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import('./components/readonly/DoTestExerciseGapFill').then((mod) => mod.DoTestExerciseGapFill)
  )
);
const DoTestExerciseGapFillQuestion = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(
    () =>
      import('./components/readonly/DoTestExerciseGapFillQuestion').then(
        (mod) => mod.DoTestExerciseGapFillQuestion
      ),
    {
      dependsOn: DoTestExerciseGapFill,
    }
  )
);
const ParagraphToggleOverrided = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('./components/readonly/ParagraphToggleOverrided').then(
      (mod) => mod.ParagraphToggleOverrided
    )
  )
);

const renderReadOnlyElementExerciseGapFill = (options) => (props) => {
  const { element } = props;
  const { onBackWhenInComplete } = options;

  switch (element.type) {
    case EXPLANATIONS: {
      return element.parentNodeType === EXERCISE_GAP_FILL ? (
        <ExplanationsElementReadOnly {...props} />
      ) : undefined;
    }

    case PARAGRAPH_TOGGLE: {
      return element.parentNodeType === EXERCISE_GAP_FILL ? (
        <ParagraphToggleOverrided {...props} />
      ) : undefined;
    }

    case EXERCISE_GAP_FILL:
      return <DoTestExerciseGapFill {...props} onBackWhenInComplete={onBackWhenInComplete} />;

    case EXERCISE_GAP_FILL_QUESTION:
      return <DoTestExerciseGapFillQuestion {...props} />;

    case EXERCISE_GAP_FILL_HINTS:
      return <Hints {...props} />;

    default:
      return undefined;
  }
};

export const ExerciseGapFillReadOnlyPlugin = (options?: ExerciseGapFillOptions): SlatePlugin => ({
  renderElement: renderReadOnlyElementExerciseGapFill(options),
  voidTypes: [EXERCISE_GAP_FILL_HINTS],
});
